export default __webpack_public_path__ + "static/media/dark-left-chevron.7960f37f.svg";